import { ANALYTICS_PLATFORM } from 'dpl/constants/analytics';

export function activeLittersV1QueryDefinition() {
  return {
    url: '/api/breeder_app/active_litters/v1.json'
  };
}

export function buyerAssignedLitterV1QueryDefinition({ id }) {
  return {
    createFetchDataConfig: { ignoreRescueOn: [404] },
    enabled: Boolean(id),
    url: `/api/breeder_app/buyer_assigned_litter/v1/${id}.json`
  };
}

export function buyerAssignedLitterV1MutationDefinition({
  id,
  litterId,
  analytics = {}
}) {
  return {
    method: 'PUT',
    enabled: Boolean(id),
    url: `/api/breeder_app/buyer_assigned_litter/v1/${id}.json`,
    params: {
      litter_id: litterId,
      analytics: {
        ...analytics,
        origin_platform: ANALYTICS_PLATFORM
      }
    }
  };
}
